/* Lieferzeit auf der Produktseite beim Varianten-Wechsel ohne Reload
   aktualisieren — gleiche Mechanik wie im alten Theme: die Bloecke aller
   Varianten liegen vorgerendert im versteckten Speicher
   (.deliveryTimesOtherVariants), beim Wechsel wird der sichtbare Block
   ersetzt und der Ausverkauft-Zustand umgeschaltet. */
(() => {
  "use strict";

  const update = (variant) => {
    document.querySelectorAll("[data-pnb-delivery]").forEach((root) => {
      const notsold = root.querySelectorAll(".state--notsold");
      const sold = root.querySelectorAll(".state--sold");

      if (!variant || !variant.available) {
        notsold.forEach((el) => el.classList.remove("showState"));
        sold.forEach((el) => el.classList.add("showState"));
        return;
      }
      notsold.forEach((el) => el.classList.add("showState"));
      sold.forEach((el) => el.classList.remove("showState"));

      /* Weihnachts-/Vorbestellungs-Blöcke tragen kein .is-available und
         bleiben — wie im alten Theme — beim Variantenwechsel unveraendert. */
      const source = root.querySelector(
        '.deliveryTimesOtherVariants .product_page--delivery-info.is-available[data-variantid="' +
          variant.id +
          '"]'
      );
      if (!source) return;
      const visible = root.querySelector(".deliveryTimeVisible");
      const target = visible && visible.querySelector(".product_page--delivery-info.is-available");
      if (target) {
        target.innerHTML = source.innerHTML;
        target.setAttribute("data-variantid", source.getAttribute("data-variantid") || "");
        target.setAttribute("data-deliverydate", source.getAttribute("data-deliverydate") || "");
      } else if (visible && !visible.querySelector(".state--christmas, .state--preorder")) {
        /* Startvariante hatte keine Lieferzeit -> Block existiert noch nicht */
        visible.innerHTML = source.outerHTML;
      }
    });
  };

  /* Dawn deklariert PUB_SUB_EVENTS als top-level `const` — das erzeugt KEINE
     window-Eigenschaft, nur eine globale lexikalische Bindung. Deshalb hier
     bare Bezeichner mit typeof-Guards (wirft nicht bei Nichtdeklaration),
     window.* nur als Fallback für Themes, die explizit ans window hängen. */
  const init = () => {
    const events =
      typeof PUB_SUB_EVENTS !== "undefined" ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    const sub = typeof subscribe === "function" ? subscribe : window.subscribe;
    if (events && events.variantChange && typeof sub === "function") {
      sub(events.variantChange, (event) => {
        const variant = event && event.data && event.data.variant;
        update(variant);
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
